import React, { useState } from "react";
import "../../../styles/FormsDropdown.css";

function FormsDropdown({
  options = [],
  placeholder = "Select...",
  handleSelect,
  value: controlledValue,
}) {
  const [internalValue, setInternalValue] = useState("");

  const value = controlledValue !== undefined ? controlledValue : internalValue;

  const handleChange = (e) => {
    const selectedValue = e.target.value;

    if (controlledValue === undefined) {
      setInternalValue(selectedValue);
    }

    handleSelect && handleSelect(selectedValue);
  };

  return (
    <div className="formsDropdown-container">
      <div className="formsDropdown-field">
       
        <div className="formsDropdown-selectWrapper">
          <select
            value={value}
            onChange={handleChange}
            className="formsDropdown-select"
          >
            <option value="">{placeholder}</option>

            {options.map((opt, index) => (
              <option key={index} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>

          <span className="formsDropdown-icon">⌄</span>
        </div>

        <p className="formsDropdown-helperText">
          Choose a form type to quickly filter and view the records you need.
        </p>
      </div>
    </div>
  );
}

export default FormsDropdown;